/**
 * A marca, num lugar só.
 *
 * Até a troca de GFI para GIFI, o nome do produto estava literal em mais de 200
 * arquivos e não havia constante nenhuma — trocar a marca custava varrer o
 * repositório inteiro, e a próxima troca custaria o mesmo. Este módulo existe
 * para que a terceira vez custe uma linha.
 *
 * ─── Onde usar a constante, e onde NÃO usar ──────────────────────────────────
 *
 * Use no **chassi**: título da janela, cabeçalho, rodapé de PDF, assunto e
 * rodapé de e-mail, prefixo de arquivo exportado, metadados. São os pontos em
 * que a marca aparece como identidade, sem estar dentro de uma frase.
 *
 * NÃO use na **prosa** de `src/content/help`, `src/content/tours` e
 * `src/content/legal`. O motivo é medido, não estético: a base de ajuda é
 * extraída por AST, e `lerValor()` em `scripts/build-help-kb.mjs` só resolve
 * `StringLiteral` e `NoSubstitutionTemplateLiteral`. Um template com `${...}`
 * vira `TemplateExpression`, devolve `undefined`, e a seção é **descartada da
 * base com um simples AVISO** (`build-help-kb.mjs:170`). Ou seja: interpolar a
 * marca na ajuda apagaria seções do assistente sem quebrar build nenhum. Lá o
 * texto fica literal, e quem garante que ele está certo é `check:brand`.
 *
 * O mesmo vale para `index.html`, `public/manifest.webmanifest` e
 * `public/sw.js`: são servidos sem passar pelo bundler e não podem importar
 * daqui. `check:brand` compara o que está escrito neles com estas constantes.
 */

/** O nome do produto. Aparece sozinho em cabeçalho, logo textual e rodapé. */
export const BRAND = "GIFI";

/** O descritivo que acompanha o nome em título, manifest e rodapé de e-mail. */
export const BRAND_TAGLINE = "Gestão Financeira de Imóveis";

/** Nome e descritivo juntos — `<title>`, Open Graph, `manifest.name`. */
export const BRAND_FULL = `${BRAND} — ${BRAND_TAGLINE}`;

/**
 * Prefixo dos arquivos que o usuário baixa.
 *
 * Era `GFIAPP` — um segundo nome de marca que só existia aqui e no rodapé dos
 * relatórios. A troca unificou em um nome só, então `GFIAPP_Imoveis_2026.csv`
 * passa a ser `GIFI_Imoveis_2026.csv`. Quem tinha rotina lendo o nome antigo
 * precisa ajustar; é o preço de não manter duas marcas.
 */
export const BRAND_EXPORT_PREFIX = BRAND;
